import $axios from 'src/utils/axios';
import IP from 'src/StoreGlobal/IP';

let companyId = parseInt(localStorage.getItem('company_id'));
let accessToken = localStorage.getItem('token');
let user_id = parseInt(localStorage.getItem('user_id'));

export const GetPhases = () => {
  return $axios.get(`phase/?limit=-1`);
};

export const GetEstimate = (project_id) => {
  let companyId = parseInt(localStorage.getItem('company_id'));

  return $axios.get(`estimate/${companyId}/${project_id}`);
};

export const SearchSow = (dataVal, project_id, sow_id, search) => {
  let companyId = parseInt(localStorage.getItem('company_id'));
  return $axios.get(`estimate/${companyId}/${project_id}?sow=${sow_id}&search=${search}`);
};

export const GetUnits = () => {
  return $axios.get('estimate/units');
};

export const GetActualCost = (project_id) => {
  return $axios.get(`/estimate/actual-cost-computation`, { params: { project_id } });
};


export const GetCompanyWorkItemDescription = () => {
  return $axios.get(`estimate/company-tag`);
}

export const CalculatorDetails = (data) => {
  return $axios.post('calculator/detail', data);
}

export const CreateEquipmentCategory = (data) => {
  return $axios.post('equipment/category/create', data);
}
export const GetStandardPhase = (project_id) => {
  return $axios.get(`phase/v2/?limit=25&standard=1&project_id=${project_id}`);
}

export const GetWorkItem = ({ project_id, phase_category_id, workItemInput = '' }) => {
  return $axios.get(`phase/v2/sowlist/?project_id=${project_id}&standard=1&phase_category_id=${phase_category_id}&sowInput=${workItemInput}`);
}

export const GetRecommendedMaterialQuantity = (data) => {
  return $axios.post(`material/get-quantity-recommendation`, data);
}

export const EstimateUploadDocument = ({ project_id, pdfFile }) => {
  const formData = new FormData();
  formData.append('file', pdfFile);
  formData.append('project_id', project_id);

  return $axios.post(`estimate/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const EstimateUploadedFilesList = (project_id) => {
  return $axios.get(`/estimate/uploaded_file/list?project_id=${project_id}&page=1&per_page=9999`);
}

export const GetEstimatePreview = (uploaded_id) => {
  return $axios.post(`/estimate/preview/details`, {
    uploaded_file_id: uploaded_id,
  });
}
export const UpdateEstimatePreview = ({ uploaded_file_id, status, data }) => {
  return $axios.post(`/estimate/uploaded_file/preview/update`, {
    uploaded_file_id: uploaded_file_id,
    status: status,
    data: data,
  })
}
export const GetEstimatePDF = (uploaded_id) => {
  return $axios.post(`/estimate/uploaded_file/preview/document`, {
    uploaded_file_id: uploaded_id,
  })
}

export const GetEstimateFinalDetails = (uploaded_id) => {
  return $axios.post(`estimate/uploaded_file/details`, {
    uploaded_file_id: uploaded_id
  })
}

export const GetEstimateStatus = (project_id) => {
  return $axios.get(`estimate/validation/status?project_id=${project_id}`);
}

export const UpdateEstimateRecords = (uploaded_id) => {
  return $axios.post(`/estimate/insert`, {
    uploaded_file_id: uploaded_id
  })
}

export const GetEstimatesValidationStatus = (uploaded_id) => {
  return $axios.post(`/estimate/uploaded_file/document/status`, {
    uploaded_file_id: uploaded_id,
  })
}

export const GetEstimateManpowerList = () => {
  return $axios.get(`/manpower/position`);
}

export const GetEstimateMaterialList = () => {
  return $axios.get(`/estimate/material-list/${companyId}`);
}

export const GetEstimateEquipmentList = () => {
  return $axios.get(`equipment/category/list`);
}

export const RejectUploadEstimate = (uploaded_file_id) => {
  return $axios.post(`/estimate/uploaded_file/preview/update`, {
    uploaded_file_id: uploaded_file_id,
    status: 7,
  })
}

export const GetSampleEstimateTemplate = () => {
  return $axios.get(`/estimate/upload/sample`);
}
